import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class MoveOutCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Move Out Cleaning Gold Coast | Exit & Vacate Cleaning"
          description="Professional move out cleaning Gold Coast. Detailed exit and vacate cleaning for rental inspections and property settlement."
          keywords="move out cleaning gold coast, vacate cleaning gold coast, exit cleaning gold coast, end of tenancy cleaning gold coast, rental property cleaning gold coast, relocation cleaning gold coast, inspection ready cleaning gold coast, professional move out cleaners gold coast, apartment move out cleaning gold coast, unit move out cleaning gold coast, carpet cleaning before inspection gold coast, full house exit cleaning gold coast, property handover cleaning gold coast, bond support cleaning gold coast, deep vacate cleaning gold coast, oven cleaning gold coast move out, bathroom deep cleaning gold coast, window cleaning before inspection gold coast, affordable move out cleaning gold coast, same day move out cleaning gold coast, urgent vacate cleaning gold coast, trusted exit cleaners gold coast, reliable rental cleaning gold coast, post tenancy cleaning gold coast, move out house sanitisation gold coast, real estate approved cleaning gold coast, house final clean gold coast, tenancy cleaning gold coast, property inspection cleaning gold coast, end of lease support cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Move Out Cleaning Gold Coast</h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Move Out Cleaning Services Gold Coast
                          </h4>
                          <p>
                            Preparing a property for final inspection requires
                            detailed cleaning. Our move out cleaning Gold Coast
                            service ensures your home is left in excellent
                            condition.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Complete Exit Cleaning
                          </h4>
                          <p>Our move out cleaning includes:</p>
                          <ul className="list-check primary">
                            <li>Kitchen cleaning</li>
                            <li>Bathroom sanitisation</li>
                            <li>Carpet vacuuming</li>
                            <li>Floor mopping</li>
                            <li>Window cleaning</li>
                            <li>Surface wiping</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Bond Cleaning Add On
                          </h4>
                          <p>
                            We can combine move out cleaning with bond cleaning
                            and carpet steam cleaning.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Why Choose Kangaroo Shine
                          </h4>
                          <ul className="list-check primary">
                            <li>Experienced professional cleaners</li>
                            <li>Inspection ready cleaning</li>
                            <li>Flexible scheduling</li>
                            <li>Affordable pricing</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">Service Areas</h4>
                          <ul className="list-check primary">
                            <li>Gold Coast</li>
                            <li>Broadbeach</li>
                            <li>Burleigh Heads</li>
                            <li>Southport</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Book Move Out Cleaning Today
                          </h4>
                          <p>
                            Contact Kangaroo Shine Property Services for
                            professional move out cleaning Gold Coast.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default MoveOutCleaningGoldCoast;
